import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface TisSnackbarData {
  /** Optional title above the message (e.g. "Notification") */
  title?: string;
  /** Main message text */
  message: string;
  /** Preset icon + colour theme */
  type?: 'success' | 'error' | 'warning' | 'info' | 'notification';
  /** Label on the right-hand action button. Pass null/undefined to hide. */
  actionLabel?: string;
  /** Override the Material icon name (e.g. 'check_circle', 'notifications') */
  icon?: string;
  /** Action to perform when the action button is clicked */
  action?: () => void;
}

@Component({
  selector: 'app-tis-snackbar',
  templateUrl: './tis-snackbar.component.html',
  styleUrls: ['./tis-snackbar.component.scss'],
  standalone: false,
})
export class TisSnackbarComponent {

  readonly iconMap: Record<NonNullable<TisSnackbarData['type']>, string> = {
    success: 'check_circle',
    error: 'cancel',
    warning: 'warning',
    info: 'info',
    notification: 'notifications',
  };

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: TisSnackbarData,
    public snackBarRef: MatSnackBarRef<TisSnackbarComponent>
  ) {}

  get icon(): string {
    return this.data.icon ?? (this.data.type ? this.iconMap[this.data.type] : 'notifications');
  }

  onAction(): void {
    if (this.data.action) {
      this.data.action();
    }
    this.snackBarRef.dismissWithAction();
  }

  onCancel(): void {
    this.snackBarRef.dismiss();
  }
}
